import { Helmet } from "react-helmet-async";

import { createFileRoute } from "@tanstack/react-router";
import { List } from "~/features/community";
import { articleGetList } from "~/features/article";

import { z } from "zod";

const communitySearchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().catch(9),
  keyword: z.string().catch(""),
});

type CommunitySearchSchema = z.infer<typeof communitySearchSchema>;

export const Route = createFileRoute("/_layout/article/community/")({
  validateSearch: (search: Record<string, unknown>): CommunitySearchSchema => communitySearchSchema.parse(search),
  loaderDeps: ({ search: { keyword, limit, page } }) => ({ keyword, limit, page }),
  loader: ({ context: { queryClient }, deps: { page } }) =>
    queryClient.ensureQueryData(
      articleGetList({
        type: "community",
        page,
        limit: 9,
      }),
    ),
  gcTime: 0,
  shouldReload: false,
  component: () => (
    <>
      <Helmet>
        <title>Komunitas - Ecobiz</title>
      </Helmet>
      <List />
    </>
  ),
});
